import { Routes, Route, Navigate } from 'react-router-dom'

import MachineListView from 'Presentation/Views/Machine/List/View'
import MachineFormView from 'Presentation/Views/Machine/Form/View'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const MachineRoutes = () => (
  <Routes>
    <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.machine} />}>
      <Route path=':id' element={<MachineFormView />} />

      <Route path='create' element={<MachineFormView />} />

      <Route index element={<MachineListView />} />

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default MachineRoutes
